// Import Slick Carousel
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Collapse, Modal, initTWE } from "tw-elements";
initTWE({ Collapse, Modal });

(function ($) {
    "use strict";

    $(document).ready(function () {

        /*******************************************/
        /* VARIABLES */
        /*******************************************/

        var mobile_width = 991,
            $window = $(window),
            $body = $('body'),
            $wpcf7 = $('.wpcf7'),
            $expandsub = $('.expand-sub');

        /*******************************************/
        /* HEADER - MOBILE MENU */
        /*******************************************/

        const $hamburger = $('.js-hamburger');
        const $mobileMenu = $('.mobile-menu');
        const $mobileMenuClose = $('.mobile-menu-close');

        // Inject +/- toggle buttons for items with submenus (mobile only)
        $mobileMenu.find('.primary-menu li.menu-item-has-children').each(function () {
            if (!$(this).children('.mobile-submenu-toggle').length) {
                $(this).append('<button class="mobile-submenu-toggle" aria-label="פתח תפריט">+</button>');
            }
        });

        // Toggle submenu on button OR link click (for items with children)
        $mobileMenu.on('click', '.menu-item-has-children > a, .mobile-submenu-toggle', function (e) {
            e.preventDefault();
            var $li = $(this).closest('li.menu-item-has-children');
            var $submenu = $li.children('ul.sub-menu');
            var isOpen = $li.hasClass('is-open');

            if (isOpen) {
                // Closing: lock in the current height, then collapse to 0
                $submenu.css('max-height', $submenu[0].scrollHeight + 'px');
                requestAnimationFrame(function() {
                    $submenu.css('max-height', '0');
                });
                $li.removeClass('is-open');
                $li.children('.mobile-submenu-toggle').text('+');
            } else {
                // Opening: set the exact content height
                $submenu.css('max-height', $submenu[0].scrollHeight + 'px');
                $li.addClass('is-open');
                $li.children('.mobile-submenu-toggle').text('−');
            }
        });

        function openMobileMenu() {
            $hamburger.addClass('is-active');
            $mobileMenu.addClass('is-active');
            $body.addClass('menu-open');

            setTimeout(function() {
                // Stagger animation for top-level items
                $mobileMenu.find('.primary-menu > ul > li').each(function (i) {
                    var $li = $(this);
                    setTimeout(function () {
                        $li.addClass('menu-item-animate');
                    }, i * 200);
                });
            }, 500);
        }

        function closeMobileMenu() {
            $hamburger.removeClass('is-active');
            $mobileMenu.removeClass('is-active');
            $body.removeClass('menu-open');
            // Remove classes only after the menu has closed
            setTimeout(function() {
                $mobileMenu.find('.primary-menu > ul > li').removeClass('menu-item-animate');
                $mobileMenu.find('.menu-item-has-children.is-open')
                    .removeClass('is-open')
                    .children('.mobile-submenu-toggle').text('+')
                    .children('ul.sub-menu').css('max-height', '0');

            }, 800);
        }

        // Hamburger click
        $hamburger.on('click', function() {
            if ($mobileMenu.hasClass('is-active')) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        });

        // Close button click
        $mobileMenuClose.on('click', closeMobileMenu);

        // Click outside menu closes it
        $(document).on('click', function(e) {
            if (!$mobileMenu.hasClass('is-active')) return;
            var $target = $(e.target);
            if ($target.closest('.mobile-menu').length || $target.closest('.js-hamburger').length) return;
            closeMobileMenu();
        });

        /*******************************************/
        /* HEADER - MINI CART */
        /*******************************************/

        const $desktopCartToggle = $('#desktop-cart-toggle');
        const $mobileCartToggle = $('#mobile-cart-toggle');
        const $miniCartSidebar = $('.mini-cart-sidebar');
        const $miniCartClose = $('.mini-cart-close');
        const $miniCartOverlay = $('.mini-cart-overlay');

        // Open cart function
        function openMiniCart() {
            $miniCartSidebar.removeClass('-translate-x-full');
            $miniCartOverlay.removeClass('hidden');
            $body.css('overflow', 'hidden');
        }

        // Close cart function
        function closeMiniCart() {
            $miniCartSidebar.addClass('-translate-x-full');
            $miniCartOverlay.addClass('hidden');
            $body.css('overflow', '');
        }

        // Desktop cart toggle
        $desktopCartToggle.on('click', function(e) {
            e.preventDefault();
            openMiniCart();
        });

        // Mobile cart toggle
        $mobileCartToggle.on('click', function(e) {
            e.preventDefault();
            openMiniCart();
        });

        // Close cart buttons
        $miniCartClose.on('click', closeMiniCart);
        $miniCartOverlay.on('click', closeMiniCart);

        /*******************************************/
        /* HEADER - SEARCH OVERLAY */
        /*******************************************/

        const $searchWrapper = $('#search-overlay-wrapper');
        const $searchOverlay = $('#search-overlay');
        const $searchBackdrop = $('#search-backdrop');
        const $searchBtn = $('#site-search, #site-search-mobile');
        const $searchCloseBtn = $('#search-close');
    
        // Get scrollbar width
        function getScrollbarWidth() {
            return window.innerWidth - document.documentElement.clientWidth;
        }
    
        // Toggle search (open/close)
        $searchBtn.on('click', function(e) {
            e.preventDefault();
            
            // If already open - close
            if (!$searchWrapper.hasClass('hidden')) {
                closeSearch();
                return;
            }
            
            // Save scrollbar width and add padding
            const scrollbarWidth = getScrollbarWidth();
            $body.css('padding-right', scrollbarWidth + 'px').addClass('overflow-hidden');
            
            // Open
            $searchWrapper.removeClass('hidden');
            setTimeout(() => {
                $searchBackdrop.addClass('opacity-100');
                $searchOverlay.removeClass('-translate-y-full').addClass('translate-y-0');
            }, 10);
        });
    
        // Close search
        function closeSearch() {
            $searchBackdrop.removeClass('opacity-100');
            $searchOverlay.removeClass('translate-y-0').addClass('-translate-y-full');
            setTimeout(() => {
                $searchWrapper.addClass('hidden');
                $body.css('padding-right', '').removeClass('overflow-hidden');
            }, 300);
        }
    
        $searchCloseBtn.on('click', closeSearch);
        $searchBackdrop.on('click', closeSearch);

        /*******************************************/
        /* HEADER - DESKTOP USER DROPDOWN */
        /*******************************************/

        const $desktopUserToggle = $('.header-user-toggle');
        const $desktopUserMenu = $('.header-user-menu');
        const $desktopUserDropdown = $('.header-user-dropdown');

        $desktopUserToggle.on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const isOpen = $desktopUserMenu.hasClass('opacity-100');
            
            if (isOpen) {
                closeDesktopUserMenu();
            } else {
                openDesktopUserMenu();
            }
        });

        function openDesktopUserMenu() {
            $desktopUserMenu.removeClass('opacity-0 invisible').addClass('opacity-100 visible');
            $desktopUserToggle.find('svg').addClass('rotate-180');
        }

        function closeDesktopUserMenu() {
            $desktopUserMenu.removeClass('opacity-100 visible').addClass('opacity-0 invisible');
            $desktopUserToggle.find('svg').removeClass('rotate-180');
        }

        // Close when clicking outside
        $(document).on('click', function(e) {
            if (!$desktopUserDropdown.is(e.target) && $desktopUserDropdown.has(e.target).length === 0) {
                closeDesktopUserMenu();
            }
        });

        /*******************************************/
        /* GLOBAL - ESC KEY HANDLER */
        /*******************************************/

        $(document).on('keydown', function(e) {
            if (e.key === 'Escape') {
                // Close mobile menu
                if ($mobileMenu.hasClass('is-active')) {
                    closeMobileMenu();
                }
                // Close mini cart
                if (!$miniCartSidebar.hasClass('-translate-x-full')) {
                    closeMiniCart();
                }
                // Close search
                if (!$searchWrapper.hasClass('hidden')) {
                    closeSearch();
                }
                // Close desktop user menu
                if ($desktopUserMenu.hasClass('opacity-100')) {
                    closeDesktopUserMenu();
                }
            }
        });

        /*******************************************/
        /* CART OPERATIONS */
        /*******************************************/

        // Remove cart item
        $(document).on('click', '.remove-cart-item', function (e) {
            e.preventDefault();
            var $button = $(this);
            var $cartItem = $button.closest('.mini-cart-item');
            var cartItemKey = $button.data('cart-item-key');

            $cartItem.addClass('opacity-50');

            $.ajax({
                url: sogoc.ajaxurl,
                type: 'POST',
                data: {
                    action: 'remove_cart_item',
                    cart_item_key: cartItemKey,
                    nonce: sogoc.removeCartNonce
                },
                success: function(response) {
                    if (response.success) {
                        $cartItem.fadeOut(200, function() {
                            $(this).remove();
                            updateMiniCart();
                        });
                    }
                }
            });
        });

        // Refresh cart function
        function updateMiniCart() {
            $.ajax({
                url: sogoc.ajaxurl,
                type: 'POST',
                data: { action: 'get_mini_cart_fragments' },
                success: function(response) {
                    // Update badges
                    var $desktopToggle = $('#desktop-cart-toggle');
                    var $mobileToggle = $('#mobile-cart-toggle');
                    var $desktopBadge = $desktopToggle.find('.cart-badge');
                    var $mobileBadge = $mobileToggle.find('.cart-badge');

                    if (response.cart_count > 0) {
                        if (!$desktopBadge.length && $desktopToggle.length) {
                            $desktopToggle.append(
                                '<span class="cart-badge absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center"></span>'
                            );
                            $desktopBadge = $desktopToggle.find('.cart-badge');
                        }
                        if (!$mobileBadge.length && $mobileToggle.length) {
                            $mobileToggle.append(
                                '<span class="cart-badge absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-4 h-4 flex items-center justify-center"></span>'
                            );
                            $mobileBadge = $mobileToggle.find('.cart-badge');
                        }
                        if ($desktopBadge.length) {
                            $desktopBadge.text(response.cart_count);
                        }
                        if ($mobileBadge.length) {
                            $mobileBadge.text(response.cart_count);
                        }
                    } else {
                        $desktopBadge.remove();
                        $mobileBadge.remove();
                    }

                    if (response.content_html) {
                        $('.mini-cart-content').html(response.content_html);
                    } else if (response.cart_count === 0) {
                        $('.mini-cart-content').html(
                            '<div class="text-center py-12 mini-cart-empty gap-6 flex flex-col justify-center items-center h-full">' +
                            '<div class="mini-cart-empty-icon">' +
                            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">' +
                            '<path d="M15.7512 10.5V6C15.7512 5.00544 15.3561 4.05161 14.6529 3.34835C13.9496 2.64509 12.9958 2.25 12.0012 2.25C11.0066 2.25 10.0528 2.64509 9.34956 3.34835C8.64629 4.05161 8.25121 5.00544 8.25121 6V10.5M19.6072 8.507L20.8702 20.507C20.9402 21.172 20.4202 21.75 19.7512 21.75H4.25121C4.09341 21.7502 3.93735 21.7171 3.79315 21.6531C3.64896 21.589 3.51985 21.4953 3.41423 21.3781C3.3086 21.2608 3.22882 21.1227 3.18006 20.9726C3.1313 20.8226 3.11466 20.6639 3.13121 20.507L4.39521 8.507C4.42436 8.23056 4.55483 7.9747 4.76146 7.78876C4.96808 7.60281 5.23623 7.49995 5.51421 7.5H18.4882C19.0642 7.5 19.5472 7.935 19.6072 8.507ZM8.62621 10.5C8.62621 10.5995 8.5867 10.6948 8.51637 10.7652C8.44604 10.8355 8.35066 10.875 8.25121 10.875C8.15175 10.875 8.05637 10.8355 7.98604 10.7652C7.91571 10.6948 7.87621 10.5995 7.87621 10.5C7.87621 10.4005 7.91571 10.3052 7.98604 10.2348C8.05637 10.1645 8.15175 10.125 8.25121 10.125C8.35066 10.125 8.44604 10.1645 8.51637 10.2348C8.5867 10.3052 8.62621 10.4005 8.62621 10.5ZM16.1262 10.5C16.1262 10.5995 16.0867 10.6948 16.0164 10.7652C15.946 10.8355 15.8507 10.875 15.7512 10.875C15.6517 10.875 15.5564 10.8355 15.486 10.7652C15.4157 10.6948 15.3762 10.5995 15.3762 10.5C15.3762 10.4005 15.4157 10.3052 15.486 10.2348C15.5564 10.1645 15.6517 10.125 15.7512 10.125C15.8507 10.125 15.946 10.1645 16.0164 10.2348C16.0867 10.3052 16.1262 10.4005 16.1262 10.5Z" stroke="#212427" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
                            '</svg>' +
                            '</div>' +
                            '<p class="text-text text-2xl font-normal leading-normal">העגלה שלך ריקה</p>' +
                            '<a href="' + response.shop_url + '" class="block text-center px-6 py-3 bg-dark text-white rounded-lg hover:opacity-90 transition-opacity text-lg font-semibold mini-cart-checkout-btn">המשך לקנות</a>' +
                            '</div>'
                        );
                    }
                    
                    if (response.footer_html) {
                        var $footer = $('.mini-cart-footer');
                        if ($footer.length) {
                            $footer.replaceWith(response.footer_html);
                        } else {
                            $('.mini-cart-content').after(response.footer_html);
                        }
                    } else if (response.cart_count === 0) {
                        $('.mini-cart-footer').remove();
                    }

                    // Clear URL
                    var url = new URL(window.location);
                    url.searchParams.delete('add-to-cart');
                    url.searchParams.delete('added-to-cart');
                    history.replaceState(null, '', url);
                }
            });
        }

        /*******************************************/
        /* ARCHIVE - MOBILE CATEGORIES SIDEBAR */
        /*******************************************/

        const $mobileCategoryToggle = $('.mobile-category-toggle');
        const $mobileCategoryClose = $('.mobile-category-close');
        const $categoriesSidebar = $('.mobile-categories-sidebar');
        const $categoriesOverlay = $('.mobile-categories-overlay');

        function openCategoriesSidebar() {
            $categoriesSidebar.removeClass('translate-x-full');
            $categoriesOverlay.removeClass('hidden');
            $body.addClass('overflow-hidden');
        }

        function closeCategoriesSidebar() {
            $categoriesSidebar.addClass('translate-x-full');
            $categoriesOverlay.addClass('hidden');
            $body.removeClass('overflow-hidden');
        }

        $mobileCategoryToggle.on('click', openCategoriesSidebar);
        $mobileCategoryClose.on('click', closeCategoriesSidebar);
        $categoriesOverlay.on('click', closeCategoriesSidebar);

        /*******************************************/
        /* SLICK SLIDERS */
        /*******************************************/

        const textDirection = $("html").attr("dir");

        // Homepage Floor 1 Slider (Hero/Banner)
        $('.js-header-slider').slick({
            rtl: true,
            arrows: true,
            dots: false,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            nextArrow: '<i class="icon-nav-left icon-s cursor-pointer z-10 w-auto text-white absolute top-1/2 -translate-y-1/2"></i>',
            prevArrow: '<i class="icon-nav-right icon-s cursor-pointer z-10 w-auto text-white absolute top-1/2 -translate-y-1/2"></i>',
        });

        $('.js-homepage-floor1-slider').slick({
            rtl: true,
            arrows: true,
            dots: true,
            autoplay: false,
            autoplaySpeed: 3000,
            speed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            nextArrow: '<i class="icon-nav-left icon-s y-align cursor-pointer z-index-2 w-auto text-white"></i>',
            prevArrow: '<i class="icon-nav-right icon-s y-align cursor-pointer z-index-2 w-auto text-white"></i>',
        });

        // Homepage Floor 1 Video Poster (desktop/mobile fallback image)
        const $floor1Video = $('#homepage-floor1-video');
        if ($floor1Video.length) {
            const floor1MobileQuery = window.matchMedia('(max-width: 1023px)');
            const updateFloor1Poster = function () {
                const posterAttr = floor1MobileQuery.matches ? 'data-poster-mobile' : 'data-poster-desktop';
                const poster = $floor1Video.attr(posterAttr);
                if (poster) {
                    $floor1Video.attr('poster', poster);
                }
            };
            updateFloor1Poster();
            floor1MobileQuery.addEventListener('change', updateFloor1Poster);
        }

        // Footer Slider
        $('.js-footer-slider').slick({
            rtl: true,
            dots: false,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 1000,
            infinite: true,
            nextArrow: '<i class="icon-nav-left icon-s cursor-pointer z-20 w-auto absolute top-1/2 -translate-y-1/2 align-middle"></i>',
            prevArrow: '<i class="icon-nav-right icon-s cursor-pointer z-20 w-auto absolute top-1/2 -translate-y-1/2 align-middle"></i>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });

        // Homepage Floor 3 - Categories Slider
        $('.js-homepage-floor2-categories').slick({
            rtl: true,
            dots: false,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            nextArrow: '<i class="icon-nav-left icon-s cursor-pointer z-20 absolute left-0 top-1/2 text-dark bg-white rounded-full w-12 h-12 flex justify-center items-center slick-arrow" style="transform: translate(-38%, -50%);"></i>',
            prevArrow: '<i class="icon-nav-right icon-s cursor-pointer z-20 absolute right-0 top-1/2 text-dark bg-white rounded-full w-12 h-12 flex justify-center items-center slick-arrow" style="transform: translate(38%, -50%);"></i>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: 'unslick'
                },
            ]
        });

        $('.js-homepage-floor3-products').slick({
            rtl: true,
            dots: false,
            arrows: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            centerMode: true,
            responsive: [
                {
                    breakpoint: 2560,
                    settings: 'unslick'
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                // {
                //     breakpoint: 1024,
                //     settings: 'unslick'
                // },
            ]
                
            
        });

        // Project Slider (Main + Nav)
        $('.js-project-slider').slick({
            rtl: true,
            dots: false,
            arrows: true,
            slidesToShow: 1,
            infinite: true,
            asNavFor: '.js-project-slider-nav',
            nextArrow: '<i class="icon-nav-left icon-s y-align cursor-pointer z-index-2 w-auto pos-l-0 text-white"></i>',
            prevArrow: '<i class="icon-nav-right icon-s y-align cursor-pointer z-index-2 w-auto pos-r-0 text-white"></i>',
        });

        $('.js-project-slider-nav').slick({
            rtl: true,
            arrows: false,
            slidesToShow: 5,
            infinite: true,
            slidesToScroll: 1,
            asNavFor: '.js-project-slider',
            dots: false,
            centerMode: true,
            focusOnSelect: true
        });

        // Dynamic Project Sliders (multiple instances)
        $('[class*="js-project-slider-"]:not([class*="-nav"])').each(function() {
            var $mainSlider = $(this);
            var classList = $mainSlider.attr('class').split(' ');
            var sliderClass = '';
            
            // Find class project-slider-X
            for (var i = 0; i < classList.length; i++) {
                if (classList[i].indexOf('project-slider-') !== -1 && classList[i].indexOf('js-') === -1) {
                    sliderClass = classList[i];
                    break;
                }
            }
            
            if (!sliderClass) return;
            
            var $navSlider = $('.' + sliderClass + '-nav');
            
            $mainSlider.slick({
                rtl: true,
                dots: false,
                arrows: true,
                slidesToShow: 1,
                infinite: true,
                asNavFor: $navSlider,
                nextArrow: '<button class="slick-arrow icon-nav-left absolute left-4 top-1/2 -translate-y-1/2 bg-white rounded-full w-12 h-12 flex items-center justify-center z-10"></button>',
                prevArrow: '<button class="slick-arrow icon-nav-right absolute right-4 top-1/2 -translate-y-1/2 bg-white rounded-full w-12 h-12 flex items-center justify-center z-10"></button>',
            });
            
            $navSlider.slick({
                rtl: true,
                arrows: false,
                slidesToShow: 5,
                infinite: true,
                slidesToScroll: 1,
                asNavFor: $mainSlider,
                dots: false,
                centerMode: true,
                focusOnSelect: true
            });
        });

        // Homepage Floor 3 - Categories Slider
        $('.js-related-products').slick({
            rtl: true,
            dots: false,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            nextArrow: '<i class="icon-nav-left icon-s cursor-pointer z-20 absolute top-1/2 text-dark bg-white rounded-full w-12 h-12 flex justify-center items-center slick-arrow" style="transform: translateY(-50%);"></i>',
            prevArrow: '<i class="icon-nav-right icon-s cursor-pointer z-20 absolute top-1/2 text-dark bg-white rounded-full w-12 h-12 flex justify-center items-center slick-arrow" style="transform: translateY(-50%);"></i>',
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]
        });

        /*******************************************/
        /* AOS - INIT AFTER SLICK */
        /*******************************************/

        AOS.init({
            offset: 200,
            duration: 1000,
        });

        /*******************************************/
        /* BLOG */
        /*******************************************/

        $('.blog-cat').on('click', function () {
            $('.blog-cat').removeClass('current-cat');
            $(this).addClass('current-cat');
        });

        $('#post-category-select').on('change', function () {
            location = $(this).val();
        });

        $('#search-id').click(function () {
            $(this).closest('form').submit();
        });

        /*******************************************/
        /* FORMS - CONTACT FORM 7 */
        /*******************************************/

        // Submitting a form - adding a class to indicate loading
        $wpcf7.on('submit', function (e) {
            $(this).closest('.wpcf7').addClass('cf7-sending');
        });

        // Validation error - removing the loading indicator
        $wpcf7.on('invalid.wpcf7', function (e) {
            $(this).closest('.wpcf7').removeClass('cf7-sending');
        });

        // Successful sending with redirect
        document.addEventListener('wpcf7mailsent', function (event) {
            if (event.detail.contactFormId == 1725) return;
            if (event.detail.apiResponse && event.detail.apiResponse.redirect) {
                window.location.href = event.detail.apiResponse.redirect;
            }
        }, false);

        /*******************************************/
        /* FORMS - INPUT PLACEHOLDERS */
        /*******************************************/

        var $inputItem = $(".js-inputWrapper");
        $inputItem.length && $inputItem.each(function() {
            var $this = $(this),
                $input = $this.find(".formRow--input"),
                placeholderTxt = $input.attr("placeholder"),
                $placeholder;
            
            if (typeof placeholderTxt == 'undefined'){
                placeholderTxt = "";
            }

            $input.after('<span class="placeholder">' + placeholderTxt + "</span>"),
                $input.attr("placeholder", ""),
                $placeholder = $this.find(".placeholder"),

                $input.val().length ? $this.addClass("active") : $this.removeClass("active"),

                $input.on("focusout", function() {
                    $input.val().length ? $this.addClass("active") : $this.removeClass("active");
                }).on("focus", function() {
                    $this.addClass("active");
                });
        });

        /*******************************************/
        /* VIDEO POPUP */
        /*******************************************/

        $('.video-cubic').click(function () {
            $(this).html($(this).data('iframe')).css('background', 'none');
        });

        $('.success-video-popup').on('show.bs.modal', function() {
            var modal = $(this);
            var videoContainer = modal.find('.video-cubic');
            var videoUrl = videoContainer.data('video-url');

            if (videoUrl && videoContainer.find('iframe').length === 0) {
                var videoSrc = videoUrl.replace('watch?v=', 'embed/');
                var separator = (videoSrc.indexOf('?') === -1) ? '?' : '&';
                videoSrc += separator + 'feature=oembed&controls=1&hd=1&autohide=1&enablejsapi=1&autoplay=1&rel=0&cc_load_policy=1';

                var iframe = '<iframe width="100%" src="' + videoSrc + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';

                videoContainer.html(iframe);
            }
        });

        $('.success-video-popup').on('hide.bs.modal', function() {
            $(this).find('.video-cubic').empty();
        });

        /*******************************************/
        /* FOOTER MENU ACCORDION - MOBILE ONLY */
        /*******************************************/

        $('.js-open-footer-menu').on('click', function() {
            if ($window.width() < 1024) {
                $(this).toggleClass('active');
                $(this).next('.widget-content').toggleClass('active');
            }
        });

        // Remove active class on desktop
        $window.on('resize', function() {
            if ($window.width() >= 1024) {
                $('.js-open-footer-menu').removeClass('active');
                $('.widget-content').removeClass('active');
            }
        });


        /*******************************************/
        /* Smooth woocommerce message */
        /*******************************************/
        var $message = $('.woocommerce-message');
    
        if ($message.length) {
            // Smooth appearance
            setTimeout(function() {
                $message.addClass('show');
            }, 100);
            
            // Smooth disappearance through 3 seconds
            setTimeout(function() {
                $message.removeClass('show').addClass('fade-out');
                
                setTimeout(function() {
                    $message.remove();
                }, 500);
            }, 3000);
        }
        
        // On AJAX adding to cart
        $(document.body).on('added_to_cart', function() {
            setTimeout(function() {
                var $newMessage = $('.woocommerce-message');
                if ($newMessage.length) {
                    $newMessage.addClass('show');
                    
                    setTimeout(function() {
                        $newMessage.removeClass('show').addClass('fade-out');
                        setTimeout(function() {
                            $newMessage.remove();
                        }, 500);
                    }, 3000);
                }
            }, 100);
            
            updateMiniCart();
        });


        /*******************************************/
        /* PRODUCT TABS ACCORDION - MOBILE */
        /*******************************************/
        
        function initProductTabsAccordion() {
            // Use event delegation at the document level for reliability
            $(document).off('click', '.product-tabs-accordion .accordion-header');
            $(document).on('click', '.product-tabs-accordion .accordion-header', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                var $header = $(this);
                var $item = $header.closest('.accordion-item');
                var $accordion = $header.closest('.product-tabs-accordion');
                var $content = $item.find('.accordion-content');
                var $icon = $header.find('.accordion-icon');
                var isExpanded = $header.attr('aria-expanded') === 'true';
                
                // Close all other open elements before opening a new one
                if (!isExpanded) {
                    $accordion.find('.accordion-header[aria-expanded="true"]').not($header).each(function() {
                        var $otherHeader = $(this);
                        var $otherItem = $otherHeader.closest('.accordion-item');
                        var $otherContent = $otherItem.find('.accordion-content');
                        var $otherIcon = $otherHeader.find('.accordion-icon');
                        $otherHeader.attr('aria-expanded', 'false');
                        $otherItem.removeClass('active');
                        $otherContent.removeClass('active');
                        $otherIcon.text('+');
                    });
                    
                    // Small delay before opening a new element for smoothness
                    setTimeout(function() {
                        $header.attr('aria-expanded', 'true');
                        $item.addClass('active');
                        $content.addClass('active');
                        $icon.text('-');
                    }, 50);
                } else {
                    // Close
                    $header.attr('aria-expanded', 'false');
                    $item.removeClass('active');
                    $content.removeClass('active');
                    $icon.text('+');
                }
            });
            
            // Open the first tab by default (optional)
            // Uncomment if you want to open the first tab by default
            // var $firstItem = $accordion.find('.accordion-item').first();
            // if ($firstItem.length) {
            //     var $firstHeader = $firstItem.find('.accordion-header');
            //     $firstHeader.trigger('click');
            // }    
        }
        
            // Initialization when the page is loaded
        initProductTabsAccordion();
        
        // Initialization after the full DOM is loaded
        $(window).on('load', function() {
            initProductTabsAccordion();
        });
        
        // Initialization after AJAX update (if used)
        $(document.body).on('updated_wc_div', function() {
            initProductTabsAccordion();
        });


        /*******************************************/
        /* VARIATION SELECTION MESSAGE (replace WC alert) */
        /*******************************************/

        $('form.cart.variations_form').each(function () {
            var form = this;
            var $form = $(form);
            var $variations = $form.find('table.variations');

            if (!$variations.length) {
                return;
            }

            var $msg = $('<p class="wf-variation-alert" role="alert"></p>').hide();
            $variations.after($msg);

            // Capture phase: runs before WooCommerce's own click handler, so its window.alert() never fires
            form.addEventListener('click', function (e) {
                var btn = e.target.closest('.single_add_to_cart_button');
                if (!btn || !btn.classList.contains('disabled')) {
                    return;
                }

                e.preventDefault();
                e.stopImmediatePropagation();

                var params = window.wc_add_to_cart_variation_params || {};
                var text = btn.classList.contains('wc-variation-is-unavailable')
                    ? params.i18n_unavailable_text
                    : params.i18n_make_a_selection_text;

                if (text) {
                    $msg.text(text).stop(true, true).slideDown(150);
                }
            }, true);

            $form.on('change', '.variations select', function () {
                $msg.stop(true, true).slideUp(150);
            });
        });


        /*******************************************/
        /* PRESELECT VARIATION SWATCH FROM URL (VillaTheme "Redirect to product" from archive) */
        /*******************************************/

        if (window.location.search) {
            var $variationForm = $('form.cart.variations_form');

            if ($variationForm.length) {
                var urlParams = [];
                new URLSearchParams(window.location.search).forEach(function (value, key) {
                    if (key.indexOf('attribute_') === 0) {
                        urlParams.push({ key: key, value: value });
                    }
                });

                if (urlParams.length) {
                    var preselectAttempts = 0;
                    var preselectPoll = setInterval(function () {
                        preselectAttempts++;

                        if (!$variationForm.hasClass('vi_wpvs_variation_form_init') && preselectAttempts < 50) {
                            return;
                        }

                        clearInterval(preselectPoll);

                        urlParams.forEach(function (item) {
                            var $wrap = $variationForm.find('.vi-wpvs-variation-wrap').filter(function () {
                                return $(this).data('attribute') === item.key;
                            });
                            if (!$wrap.length) {
                                return;
                            }

                            var $option = $wrap.find('.vi-wpvs-option-wrap').filter(function () {
                                return String($(this).data('attribute_value')) === item.value;
                            });

                            // Simulate a real click so the plugin also recalculates which options
                            // of the OTHER attribute (e.g. סוג) are incompatible and crosses them out
                            if ($option.length && !$option.hasClass('vi-wpvs-option-wrap-selected')) {
                                $option.trigger('click');
                            }
                        });
                    }, 100);
                }
            }
        }


        /*******************************************/
        /* ADD WARRANTY TO CART */
        /*******************************************/

            
            var lastChecked = null;
            
            // Click on the radio button
            $(document).on('change', '.warranty-radio', function() {
                var $radio = $(this);
                lastChecked = this;

                // Update the hidden field
                var warranty_id = $radio.val();
                $('form.cart input[name="selected_warranty"]').remove();
                $('form.cart').append('<input type="hidden" name="selected_warranty" value="' + warranty_id + '">');

                // Update the active class
                $('.warranty-card').removeClass('active');
                $radio.closest('.warranty-card').addClass('active');
            });

            // Activate the first card by default when the page is loaded
            var $defaultRadio = $('.warranty-radio:checked');
            if ($defaultRadio.length) {
                var warranty_id = $defaultRadio.val();
                $('form.cart input[name="selected_warranty"]').remove();
                $('form.cart').append('<input type="hidden" name="selected_warranty" value="' + warranty_id + '">');
                $defaultRadio.closest('.warranty-card').addClass('active');
            }

    });

})(jQuery);


(function($) {

        /*******************************************/
        /* LIMIT PAYMENTS SELECT BY WARRANTY MAXPAY */
        /*******************************************/

        if (typeof sogoc !== 'undefined' && parseInt(sogoc.warrantyMaxpay) > 0) {

            var maxpay = parseInt(sogoc.warrantyMaxpay);

            function limitPaymentsSelect() {
                $('#payments-select option').each(function() {
                    if (parseInt($(this).val()) > maxpay) {
                        $(this).remove();
                    }
                });
            }

            $(document).ready(function() {
                limitPaymentsSelect();
            });

            $(document.body).on('updated_checkout', function() {
                limitPaymentsSelect();
            });

        }

})(jQuery);

/*******************************************/
/* WARRANTY FLOW                           */
/*******************************************/

(function () {
    if (!document.getElementById('warranty-flow')) return;

    var state = { step: 1, brandId: null, productId: null, plan: null };

    function showStep(n) {
        document.querySelectorAll('.warranty-step').forEach(function (el) {
            el.classList.toggle('is-active', parseInt(el.dataset.step) === n);
        });
        state.step = n;
        if (n === 6) updateStep6();
        if (n === 7) updateStep7();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function updateStep6() {
        var summary = document.getElementById('wf-plan-summary');
        if (!summary || !state.plan) return;

        var price    = parseFloat(state.plan.price)    || 0;
        var payments = parseInt(state.plan.maxPayments) || 1;
        var priceText = price > 0
            ? '₪' + Math.round(price / payments) + ' / חודש'
            : 'חינם';
        summary.textContent = state.plan.title + ' · ' + priceText;

        // Populate hidden CF7 fields if present
        var fields = {
            'plan_title':      state.plan.title,
            'plan_price':      state.plan.price,
            'plan_product_id': state.plan.productId,
        };
        Object.keys(fields).forEach(function (name) {
            var el = document.querySelector('.wf-form-wrap input[name="' + name + '"]');
            if (el) el.value = fields[name];
        });
    }

    // CF7 success → capture form data → step 7
    document.addEventListener('wpcf7mailsent', function (event) {
        state.formData = {};
        if (event.detail && event.detail.inputs) {
            event.detail.inputs.forEach(function (field) {
                state.formData[field.name] = field.value;
            });
        }
        showStep(7);
    });

    function updateStep7() {
        var fd  = state.formData || {};
        var now = new Date();

        // Activation date
        var pad = function (n) { return String(n).padStart(2, '0'); };
        var dateStr = pad(now.getDate()) + '/' + pad(now.getMonth() + 1) + '/' + now.getFullYear();
        var timeStr = pad(now.getHours()) + ':' + pad(now.getMinutes());

        // Expiry date: purchase date + (maxPayments / 12) years
        var expiryStr = '';
        var rawDate = fd['purchase-date'] || '';
        if (rawDate) {
            var parts = rawDate.split('-');
            if (parts.length === 3) {
                var pd    = new Date(+parts[0], +parts[1] - 1, +parts[2]);
                var years = Math.round((parseInt((state.plan || {}).maxPayments) || 12) / 12);
                pd.setFullYear(pd.getFullYear() + years);
                expiryStr = pad(pd.getDate()) + '/' + pad(pd.getMonth() + 1) + '/' + pd.getFullYear();
            }
        }

        var fill = {
            'plan':    (state.plan && state.plan.title) || '',
            'machine': state.machineTitle || '',
            'serial':  fd['serial-number']  || '',
            'date':    dateStr + ' · ' + timeStr,
            'expiry':  expiryStr,
            'email':   fd['your-email'] || '',
        };

        document.querySelectorAll('[data-detail]').forEach(function (el) {
            var key = el.dataset.detail;
            if (fill[key] !== undefined) el.textContent = fill[key];
        });
    }

    // Back buttons
    document.querySelectorAll('.wf-back').forEach(function (btn) {
        btn.addEventListener('click', function () {
            showStep(parseInt(this.dataset.targetStep));
        });
    });

    // Step 1: brand click → AJAX load models → step 2
    document.querySelectorAll('.wf-brand-card').forEach(function (card) {
        card.addEventListener('click', function () {
            state.brandId = this.dataset.brandId;

            var formData = new FormData();
            formData.append('action', 'warranty_get_models');
            formData.append('brand_id', state.brandId);
            formData.append('nonce', sogoc.warrantyNonce);

            fetch(sogoc.ajaxurl, { method: 'POST', body: formData, credentials: 'same-origin' })
                .then(function (r) { return r.json(); })
                .then(function (data) {
                    if (!data.success) return;
                    document.querySelector('.wf-models-list').innerHTML = data.data.html;
                    bindModelItems();
                    showStep(2);
                });
        });
    });

    // Step 2: model click → AJAX load machine → step 3
    function bindModelItems() {
        document.querySelectorAll('.wf-model-item').forEach(function (item) {
            item.addEventListener('click', function () {
                state.productId = this.dataset.productId;

                var formData = new FormData();
                formData.append('action', 'warranty_get_machine');
                formData.append('product_id', state.productId);
                formData.append('nonce', sogoc.warrantyNonce);

                fetch(sogoc.ajaxurl, { method: 'POST', body: formData, credentials: 'same-origin' })
                    .then(function (r) { return r.json(); })
                    .then(function (data) {
                        if (!data.success) return;
                        var tmp = document.createElement('div');
                        tmp.innerHTML = data.data.html;
                        var h2 = tmp.querySelector('h2');
                        state.machineTitle = h2 ? h2.textContent.trim() : '';
                        var badge = tmp.querySelector('.wf-brand-badge');
                        var brandEl = document.getElementById('wf-machine-brand');
                        if (brandEl) {
                            if (badge) {
                                brandEl.textContent = badge.textContent.trim();
                                brandEl.removeAttribute('hidden');
                            } else {
                                brandEl.setAttribute('hidden', '');
                            }
                        }
                        document.querySelector('.wf-machine-content').innerHTML = data.data.html;
                        initVideoSlider();
                        showStep(3);
                    });
            });
        });
    }

    // Step 3: CTA button → step 4 (event delegation for dynamically injected content)
    document.getElementById('warranty-flow').addEventListener('click', function (e) {
        var btn = e.target.closest('[data-goto-step]');
        if (btn) showStep(parseInt(btn.dataset.gotoStep));
    });

    // Step 4: plan selection
    var basicSheet = document.getElementById('wf-basic-sheet');

    function openBasicSheet() {
        if (!basicSheet) return;
        basicSheet.classList.add('is-active');
        basicSheet.setAttribute('aria-hidden', 'false');
        document.body.classList.add('sheet-open');
    }

    function closeBasicSheet() {
        if (!basicSheet) return;
        basicSheet.classList.remove('is-active');
        basicSheet.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('sheet-open');
    }

    if (basicSheet) {
        basicSheet.querySelectorAll('.js-sheet-close').forEach(function (el) {
            el.addEventListener('click', closeBasicSheet);
        });

        var sheetContinue = basicSheet.querySelector('.js-sheet-continue');
        if (sheetContinue) {
            sheetContinue.addEventListener('click', function () {
                closeBasicSheet();
                showStep(6);
            });
        }
    }

    document.querySelectorAll('.wf-plan-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var card = this.closest('.wf-plan-card');
            state.plan = {
                productId:   card.dataset.productId,
                title:       card.dataset.title,
                price:       card.dataset.price,
                maxPayments: card.dataset.maxPayments,
            };
            if (this.classList.contains('is-basic')) {
                openBasicSheet();
            } else {
                showStep(6);
            }
        });
    });

    // Step 2: search filter
    var searchInput = document.querySelector('.wf-search');
    if (searchInput) {
        searchInput.addEventListener('input', function () {
            var q = this.value.toLowerCase();
            document.querySelectorAll('.wf-model-item').forEach(function (item) {
                item.style.display = item.textContent.toLowerCase().includes(q) ? '' : 'none';
            });
        });
    }

    // Step 6: enhance CF7 file upload to custom upload box
    function initUploadBox() {
        document.querySelectorAll('.wf-form-wrap .wpcf7-form-control-wrap').forEach(function (wrap) {
            var input = wrap.querySelector('input[type="file"]');
            if (!input || wrap.classList.contains('wf-upload-enhanced')) return;

            wrap.classList.add('wf-upload-box', 'wf-upload-enhanced');
            input.setAttribute('style', 'position:absolute;inset:0;opacity:0;width:100%;height:100%;cursor:pointer;');
            wrap.style.position = 'relative';

            var iconEl = document.createElement('div');
            iconEl.className = 'wf-upload-icon';
            iconEl.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
                + '<path d="M10 13V4M10 4L7 7M10 4L13 7" stroke="#3F3027" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
                + '<path d="M3 14v2a1 1 0 001 1h12a1 1 0 001-1v-2" stroke="#3F3027" stroke-width="1.5" stroke-linecap="round"/>'
                + '</svg>';

            var labelEl = document.createElement('span');
            labelEl.className = 'wf-upload-label';
            labelEl.textContent = 'לחץ להעלאת חשבונית';

            var filenameEl = document.createElement('span');
            filenameEl.className = 'wf-upload-filename';

            wrap.insertBefore(iconEl, input);
            wrap.insertBefore(labelEl, input);
            wrap.appendChild(filenameEl);

            input.addEventListener('change', function () {
                filenameEl.textContent = this.files && this.files[0] ? this.files[0].name : '';
            });
        });
    }
    initUploadBox();

    // Replace CF7 submit input with <button> to support icon-nav-left
    (function () {
        var input = document.querySelector('.wf-form-wrap input[type="submit"]');
        if (!input) return;
        var btn = document.createElement('button');
        btn.type = 'submit';
        btn.className = input.className;
        // Strip any trailing arrow characters from CF7 label
        btn.innerHTML = input.value.replace(/\s*[←→↑↓<>‹›»«]+\s*$/, '').trim()
            + ' <span class="icon-nav-left" aria-hidden="true"></span>';
        input.parentNode.replaceChild(btn, input);
    })();

    // ---- Video modal ----
    var videoModal  = document.getElementById('wf-video-modal');
    var videoIframe = document.getElementById('wf-video-iframe');

    function youtubeEmbedUrl(url) {
        var m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
        return m ? 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1&rel=0' : '';
    }

    function openVideoModal(embedUrl) {
        if (!videoModal || !videoIframe) return;
        videoIframe.src = embedUrl;
        videoModal.classList.add('is-active');
        videoModal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('sheet-open');
    }

    function closeVideoModal() {
        if (!videoModal || !videoIframe) return;
        videoModal.classList.remove('is-active');
        videoModal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('sheet-open');
        // Stop video by clearing src after transition
        setTimeout(function () { videoIframe.src = ''; }, 300);
    }

    // Event delegation — works for dynamically loaded AJAX content
    document.addEventListener('click', function (e) {
        var card = e.target.closest('.wf-video-card');
        if (!card) return;
        e.preventDefault();
        var embed = youtubeEmbedUrl(card.getAttribute('href'));
        if (embed) openVideoModal(embed);
    });

    document.querySelectorAll('.js-video-close').forEach(function (el) {
        el.addEventListener('click', closeVideoModal);
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && videoModal && videoModal.classList.contains('is-active')) {
            closeVideoModal();
        }
    });

    function initVideoSlider() {
        var $s = jQuery('.wf-video-slider');
        if (!$s.length) return;
        if ($s.hasClass('slick-initialized')) $s.slick('unslick');
        $s.slick({
            rtl: true,
            dots: true,
            arrows: false,
            infinite: false,
            slidesToShow: 1.4,
            slidesToScroll: 1,
            speed: 300,
            cssEase: 'ease-in-out',
        });
    }


})();